import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";

export default function ImpressumPage() {
    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <>
            <Navigation />

            <section
                data-testid="impressum-page"
                className="relative pt-32 lg:pt-40 pb-24 lg:pb-32 bg-[#FEFEFE]"
            >
                <div className="max-w-4xl mx-auto px-6 lg:px-12">
                    <Link
                        to="/"
                        data-testid="impressum-back-link"
                        className="inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase text-[#14100D]/60 hover:text-[#E20514] transition-colors"
                    >
                        <ArrowLeft size={14} /> Zurück zur Startseite
                    </Link>

                    <div className="mt-10">
                        <div className="eyebrow mb-6">Impressum</div>
                    </div>

                    <div className="mt-16 space-y-12 text-[#14100D]">
                        <Block title="Firmenname">
                            <p>CLER BAU AG</p>
                            <p className="text-[#14100D]/60 text-sm mt-1">Aktiengesellschaft</p>
                        </Block>

                        <Block title="Adresse">
                            <p>Talstrasse 1</p>
                            <p>8852 Altendorf</p>
                            <p>Schweiz</p>
                        </Block>

                        <Block title="Kontakt">
                            <p>
                                Telefon:{" "}
                                <a href="tel:+41440000000" className="hover:text-[#E20514]">
                                    +41 44 000 00 00
                                </a>
                            </p>
                            <p>
                                E-Mail:{" "}
                                <a href="mailto:info@clerbau.ch" className="hover:text-[#E20514]">
                                    info@clerbau.ch
                                </a>
                            </p>
                        </Block>

                        <Block title="Register-Angaben">
                            <p>Sitz: Altendorf, Kanton Schwyz</p>
                            <p>UID: CHE-491.359.224</p>
                            <p>CH-ID: CH-130-3031840-5</p>
                            <p>EHRA-ID: 1567354</p>
                            <p>Handelsregister: Handelsregisteramt des Kantons Schwyz</p>
                        </Block>

                        <Block title="Vertretungsberechtigte Person">
                            <p>Blerta Krasniqi, Mitglied mit Einzelunterschrift</p>
                        </Block>

                        <Block title="Zweck der Gesellschaft">
                            <p className="leading-relaxed text-[15px] text-[#14100D]/80">
                                Die Gesellschaft bezweckt die Verwaltung, Entwicklung und Vermittlung von Immobilien, das Baumanagement, die Tätigkeit als Bauträger sowie die Planung, den Bau und die Baubetreuung von Bauwerken für eigene und fremde Rechnung.
                            </p>
                        </Block>

                        <Block title="Haftungsausschluss">
                            <p className="leading-relaxed text-[15px] text-[#14100D]/80">
                                Die CLER BAU AG übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen auf dieser Webseite. Haftungsansprüche gegen die CLER BAU AG wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen entstehen, werden ausgeschlossen.
                            </p>
                        </Block>

                        <Block title="Urheberrecht">
                            <p className="leading-relaxed text-[15px] text-[#14100D]/80">
                                Alle Inhalte dieser Webseite (Texte, Bilder, Grafiken, Logos) sind urheberrechtlich geschützt. Eine Verwendung, Vervielfältigung oder Verbreitung – auch auszugsweise – bedarf der vorgängigen schriftlichen Zustimmung der CLER BAU AG.
                            </p>
                        </Block>

                        <Block title="Anwendbares Recht und Gerichtsstand">
                            <p className="leading-relaxed text-[15px] text-[#14100D]/80">
                                Es gilt ausschliesslich schweizerisches Recht. Ausschliesslicher Gerichtsstand ist Altendorf, Kanton Schwyz.
                            </p>
                        </Block>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

function Block({ title, children }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-6 md:gap-10 pb-8 border-b border-[rgba(20,16,13,0.1)]">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#E20514] font-medium leading-relaxed">
                {title}
            </div>
            <div className="text-[15px] text-[#14100D]/85 space-y-1">
                {children}
            </div>
        </div>
    );
}
